import get from 'lodash/get'
import { getAppData, getApiKey } from '@/utils'

function beforeNav (to, from, next) {
	this._prevRoute = from
	const name = get(to, 'name')
	let parent = get(to, 'meta.parent')
	const fromSlug = get(from, 'name')
	const key = getApiKey()

	// Can we proceed to the intended route?
	let goahead = true

	switch (name) {
	case '404':
		const route = this.getRouteForQuery()
		if (route) {
			if (get(to, 'hash')) {
				route.hash = to.hash
			}

			// If we're not changing routes, then don't go ahead.
			if (route.name === fromSlug) {
				goahead = false
			}

			parent = get(route, 'meta.parent')
			this.replace(route)
		}
		break
	case 'connect':
		if (key) {
			goahead = false
		}
		// Prevents getting in a redirect loop.
		break
	default:
		break
	}

	// If we proceed to the intended route...
	if (goahead) {
		// let's do that.
		next()

		if (getAppData('main') && !parent) {
			// And let's put a transitioning class on.
			getAppData('main').app.$el.classList.add('transitioning')
		}

		return
	}

	// If the user is landing here (w/o history)
	// AND they are not allowed to proceed to the intended route...
	if (!fromSlug) {
		// Then just send them home.
		this.replace({ name: 'dashboard' })
	}
}

function navComplete (to, from) {
	// Trigger event
	getAppData('$events').trigger('Navigation.complete', { to, from })

	if (!to.name) {
		return
	}

	setTimeout(() => {
		if (getAppData('main')) {
			getAppData('main').app.$el.classList.remove('transitioning')
		}
	})

	// Update document/banner title.
	this.app.$store.dispatch('setTitle', { title: get(to, 'meta.title', 'OptinMonster') })

	const toPath = to.fullPath || to.path
	if (toPath !== (from.fullPath || from.path)) {
		this.app.$store.commit('incrementVisits', toPath)
	}

	let route = to
	const parent = get(to, 'meta.parent')
	if (parent) {
		route = this.getRouteForSlug(parent) || route
	}

	resetCurrentMenuItems.call(this, route)
	resetCurrentBodyClasses.call(this, route)
}

const navGuards = {
	beforeEach : beforeNav,
	afterEach  : navComplete,
}

/**
 * Handles resetting "current" menu items in the WP sidebar.
 *
 * @since  2.0.0
 *
 * @param  {Object} route The route object.
 *
 * @returns {void}
 */
function resetCurrentMenuItems (route) {
	// Reset "current" menu items in the WP sidebar.
	const menu = document.getElementById('toplevel_page_optin-monster-dashboard')
	const current = menu.querySelectorAll('.current')

	if (current) {
		current.forEach(link => {
			link.classList.remove('current')
		})
	}

	const a = menu.querySelector(`.wp-submenu [href*="${route.path}"]`)

	if (a) {
		a.classList.add('current')
		a.parentNode.classList.add('current')
	}
}

/**
 * Resets the body class with the new route slug
 *
 * @since  2.0.0
 *
 * @param  {Object} route The route object.
 *
 * @returns {void}
 */
function resetCurrentBodyClasses (route) {
	for (let i = document.body.classList.length - 1; 0 <= i; i--) {
		let cl = document.body.classList[i]
		if (cl.match('omapi-app-')) {
			document.body.classList.remove(cl)
		}
	}

	document.body.classList.add(`omapi-app-${route.name || route.meta.slug}`)
}

const set = (router) => {
	Object.keys(navGuards).forEach(method => {
		router[method](navGuards[method].bind(router))
	})

	return router
}

export default { ...navGuards, set }
